import axios from 'axios'
import { API } from 'src/feature/bite/domain'

interface RegionListResponse {
  response: {
    regions: {
      id: string
      name: string
      postalCode: string
      cityId: string
    }[]
  }
}

export default async function getRegionsByCity(cityId: string) {
  const response = await axios.post<RegionListResponse>(
    `${API}/Region/GetRegionsByCity`,
    {
      cityId,
    }
  )
  return response.data.response.regions
}
